import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AddTagFormData } from '../types';
import { FormToggle } from '../components/FormToggle';
import {
  SAMPLE_CREATED_WITH_FIELDS,
  SAMPLE_CREATED_WITH_DESCRIPTIONS,
} from '../constants';

export function SampleCreatedWithSection({
  showFabric = true,
  showTrim = true,
  showLabel = true,
  showWashColor = true,
}: {
  showFabric?: boolean;
  showTrim?: boolean;
  showLabel?: boolean;
  showWashColor?: boolean;
} = {}) {
  const { control } = useFormContext<AddTagFormData>();

  const fieldVisibility = {
    fabricType: showFabric,
    trimType: showTrim,
    labelType: showLabel,
    washColorType: showWashColor,
  };

  const visibleFields = SAMPLE_CREATED_WITH_FIELDS.filter(
    (field) => fieldVisibility[field.name],
  );

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <div className="space-y-1">
        <h4 className="text-sm font-medium text-gray-900">
          Sample Created With
          <span className="text-danger-700 ml-1">*</span>
        </h4>
        <p className="text-xs text-base-disabled">
          {SAMPLE_CREATED_WITH_DESCRIPTIONS.AVAILABLE}
        </p>
        <p className="text-xs text-base-disabled pb-2">
          {SAMPLE_CREATED_WITH_DESCRIPTIONS.PRODUCTION}
        </p>

        <div className="space-y-1">
          {visibleFields.map((field) => (
            <div key={field.name} className="flex items-center gap-4">
              <span className="text-sm font-medium text-gray-700 w-24">
                {field.label}
              </span>
              <FormToggle
                name={field.name}
                control={control}
                options={[
                  { label: 'Available', value: 'Available' },
                  { label: 'Production', value: 'Production' },
                ]}
                rules={{
                  validate: (value) =>
                    value !== undefined || `Please select ${field.label}`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
